import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SendEvent from './pages/SendEvent';
import NotFound from './pages/NotFound';
import UserPage from '@/pages/Users';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute adminOnly={true}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute adminOnly={true}>
            <UserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/send-event"
        element={
          <ProtectedRoute>
            <SendEvent />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
